import { Component, Renderer2, OnInit, HostListener } from '@angular/core';
import { DatasearchService } from '../../_services/datasearch.service';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-ethics',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, NgFor, NgIf, NgClass],
  templateUrl: './ethics.component.html',
  styleUrls: ['./ethics.component.scss']
})
export class EthicsComponent implements OnInit {
  data: any;
  highlightedIndex: number | null = null;
  currentPage: string = 'ethics';
  head: any[] = [];

  constructor(private datasearchService: DatasearchService, private renderer: Renderer2) {}

  ngOnInit() {
    this.getData();
    this.getHeading();
  }

  ngAfterViewInit() {
    this.observeScrolling(); // Start observing after the view is initialized
  }

  getData() {
    this.datasearchService.getEthics().subscribe(res => {
      this.data = res.data;
    });
  }

  observeScrolling() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        if (id) {
          const index = parseInt(id.split('-')[1], 10);  // Get the index from the ID
          const titleElement = document.getElementById('title-' + index);

          if (entry.isIntersecting && titleElement) {
            this.highlightedIndex = index; // Set highlighted index based on description in view
            this.renderer.addClass(titleElement, 'highlight'); // Add highlight class to title
          } else if (titleElement) {
            this.renderer.removeClass(titleElement, 'highlight'); // Remove highlight class when out of view
          }
        }
      });
    }, { threshold: 0.4, rootMargin: '0px' }); // Adjust rootMargin if necessary

    // Start observing only after the view is rendered
    setTimeout(() => {
      this.data?.forEach((_: any, i: number) => {
        const descriptionElement = document.getElementById('description-' + i);
        if (descriptionElement) {
          observer.observe(descriptionElement); // Observe each description
        }
      });
    }, 0);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    this.data.forEach((_: any, i: number) => {
      const descriptionElement = document.getElementById('description-' + i);
      if (descriptionElement) {
        const rect = descriptionElement.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          this.highlightedIndex = i; // Manually set highlighted index
        }
      }
    });
  }

  getHeading() {
    this.datasearchService.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
toggleDescription(index: number) {
  // Toggle the highlightedIndex based on the clicked item
  if (this.highlightedIndex === index) {
    // If the same index is clicked, collapse it (hide description)
    this.highlightedIndex = null;
  } else {
    // Otherwise, show the clicked description
    this.highlightedIndex = index;
  }

  // Scroll the description element into view within its parent container
  const descriptionElement = document.getElementById('description-' + index);
  const container = document.querySelector('.ethics_bottom_body'); // Specify the container that should scroll
  if (descriptionElement && container) {
    descriptionElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest', // Scrolls to the nearest part of the container, instead of scrolling the entire page
      inline: 'center'   // Ensures horizontal scrolling is minimized
    });
  }
}
}

// import { Component, Renderer2, OnInit, HostListener, AfterViewInit } from '@angular/core';
// import { DatasearchService } from '../../_services/datasearch.service';
// import { FooterComponent } from '../footer/footer.component';
// import { HeaderComponent } from '../header/header.component';
// import { NgClass, NgFor, NgIf } from '@angular/common';
// import { BusyService } from '../../_services/busy.service';

// @Component({
//   selector: 'app-ethics',
//   standalone: true,
//   imports: [FooterComponent, HeaderComponent, NgFor, NgIf, NgClass],
//   templateUrl: './ethics.component.html',
//   styleUrls: ['./ethics.component.scss']
// })
// export class EthicsComponent implements OnInit, AfterViewInit {
//   data: any;
//   highlightedIndex: number | null = null;
//   currentPage: string = 'ethics';
//   head: any[] = [];
//   selected: any = "";

//   constructor(
//     private datasearchService: DatasearchService, 
//     private renderer: Renderer2, 
//     private busyService: BusyService,
//   ) {}

//   ngOnInit() {
//     this.getData();
//     this.getHeading();
//   }

//   ngAfterViewInit() {
//     // this.observeScrolling(); // Start observing after the view is initialized
//   }

//   scrollToSection(elem: string): void {
//     this.selected = elem;
//     const headerOffset = 140; 
//     const element = document.getElementById(elem);

//     if (element) {
//       const elementPosition = element.getBoundingClientRect().top + window.scrollY;
//       const offsetPosition = elementPosition - headerOffset;

//       window.scrollTo({
//         top: offsetPosition,
//         behavior: 'smooth',
//       });
//     }
//   }

//   getData() {
//     this.busyService.busy();
//     this.datasearchService.getEthics().subscribe((res: any) => {
//       this.busyService.idle();
//       this.data = res.data;
//       this.selected = this.data[0].title;
//     }, (err: any) => {
//       this.busyService.idle();
//       console.log(err);
//     });
//   }

//   observeScrolling() {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         const id = entry.target.getAttribute('id');
//         if (id) {
//           const index = parseInt(id.split('-')[1], 10);
//           const titleElement = document.getElementById('title-' + index);

//           if (entry.isIntersecting && titleElement) {
//             this.highlightedIndex = index; 
//             this.renderer.addClass(titleElement, 'highlight');
//             this.highlightSidebarItem(index);
//           } else if (titleElement) {
//             this.renderer.removeClass(titleElement, 'highlight');
//           }
//         }
//       });
//     }, { threshold: 0.4, rootMargin: '0px' });

//     setTimeout(() => {
//       this.data?.forEach((_: any, i: number) => {
//         const descriptionElement = document.getElementById('description-' + i);
//         if (descriptionElement) {
//           observer.observe(descriptionElement);
//         }
//       });
//     }, 0);
//   }

//   @HostListener('window:scroll', ['$event'])
//   onWindowScroll(event: Event) {
//     // this.data.forEach((_: any, i: number) => {
//     //   const descriptionElement = document.getElementById('description-' + i);
//     //   if (descriptionElement) {
//     //     const rect = descriptionElement.getBoundingClientRect();
//     //     if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
//     //       this.highlightedIndex = i; // Manually set highlighted index
//     //       this.highlightSidebarItem(i); // Highlight the sidebar item
//     //     }
//     //   }
//     // });
//     const scrollContainer = event.target as HTMLElement;
//     const sections = this.data.map((item:any) => document.getElementById(item.title));
    
//     for (const section of sections) {
//       if (section) {
//         const rect = section.getBoundingClientRect();
//         if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
//           this.selected = section.id;
//           break;
//         }
//       }
//     }
//   }

//   // Highlight the corresponding sidebar item
//   highlightSidebarItem(index: number) {
//     // Remove highlight class from all sidebar items
//     const sidebarItems = document.querySelectorAll('.sidebar-item');
//     sidebarItems.forEach((item: any) => {
//       this.renderer.removeClass(item, 'highlighted');
//     });

//     // Add highlight class to the current sidebar item
//     const sidebarItem = document.getElementById('sidebar-section-' + index);
//     if (sidebarItem) {
//       this.renderer.addClass(sidebarItem, 'highlighted');
//     }
//   }
//   onScroll(event:any){
//     console.log(event);
//   }
//   getHeading() {
//     this.datasearchService.getAllHeadings().subscribe((res:any) => {
//       if (res.success) {
//         this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
//       }
//     });
//   }

//   toggleDescription(index: number) {
//     // Toggle the highlightedIndex based on the clicked item
//     if (this.highlightedIndex === index) {
//       this.highlightedIndex = null;
//     } else {
//       this.highlightedIndex = index; 
//     }

//     const descriptionElement = document.getElementById('description-' + index);
//     const container = document.querySelector('.ethics_bottom_body');
//     if (descriptionElement && container) {
//       descriptionElement.scrollIntoView({
//         behavior: 'smooth',
//         block: 'nearest', 
//         inline: 'center'
//       });
//     }
//   }
// }
